import { ColetaFluxo, ColetaFluxoFila } from '../../types/coleta';

export function podeAcionarColetaManual(isAdmin: boolean, isCqv: boolean): boolean {
  return Boolean(isAdmin || isCqv);
}

export function filaColetaOcupada(fila?: ColetaFluxoFila | null): boolean {
  return fila?.estado === 'na_fila' || fila?.estado === 'em_andamento';
}

export function temDadoDeColeta(fluxo: ColetaFluxo | null): boolean {
  return Boolean(fluxo?.resultado);
}

export function fluxoColetaAceito(fluxo: ColetaFluxo | null): boolean {
  return Boolean(fluxo?.utilizavel || fluxo?.fila);
}

export const MENSAGEM_COLETA_SEM_FILA =
  'A coleta não entrou na fila. Tente de novo ou confira o login P2B e o CNPJ.';

export function visibilidadeBotoesColeta(opcoes: {
  temCnpj: boolean;
  podeAcionar: boolean;
  fluxoCarregado: boolean;
  temResultado: boolean;
  ocupado: boolean;
}): { retentar: boolean; atualizar: boolean } {
  if (!opcoes.temCnpj || !opcoes.podeAcionar || !opcoes.fluxoCarregado || opcoes.ocupado) {
    return { retentar: false, atualizar: false };
  }
  if (opcoes.temResultado) return { retentar: false, atualizar: true };
  return { retentar: true, atualizar: false };
}

export function visibilidadeBotaoAtualizarOrigem(opcoes: {
  podeAcionar: boolean;
  temSecao: boolean;
  ocupado: boolean;
}): boolean {
  return Boolean(opcoes.podeAcionar && opcoes.temSecao && !opcoes.ocupado);
}

export function visibilidadeBotaoPriorizar(podeAcionar: boolean, podePriorizar: boolean): boolean {
  return Boolean(podeAcionar && podePriorizar);
}
